import React, { useEffect, useState } from "react";
import {
  Button,
  Drawer,
  DropdownMenu,
  TableAdv,
  showToast,
  SmartTooltip,
  ToolTip,
} from "../../../../../../components";
import {
  formatNumber,
  getEmployeeId,
  mapTableRows,
} from "../../../../../../utils";
import FinalizeModal from "../Modals/FinalizeModal";
import ProposedEmployeesDetails from "./ProposedEmployeesDetails/ProposedEmployeesDetails";
import { totalCountStart } from "../../../../../../redux/slices/totalCount/totalCountSlice";
import {
  clearCurrentPayrollEditing,
  clearEmpPayConfigMain,
  clearPayroll,
  getAllEmpPayConfigsStart,
  getAllPayrollStart,
  updatePayrollStart,
} from "../../../../../../redux/slices/payroll/payrollSlice";
import { usePagination } from "../../../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { formatCurrency } from "../../../../../../utils/stringUtils";

const ProposedEmployees = ({ configData }) => {
  const dispatch = useDispatch();
  const { payroll: ProposedEmployees, loading } =
    useSelector((state) => state.payRoll) || {};
  const { value } = useSelector((state) => state.totalCount);
  const [searchQuery, setSearchQuery] = useState("");

  const isAggregate = !!ProposedEmployees?.data?.[0]?.data;
  const dataArray = isAggregate ? ProposedEmployees.data[0].data : (ProposedEmployees?.data || []);
  const totalCount = isAggregate ? (ProposedEmployees?.data?.[0]?.count?.[0]?.total || 0) : value?.payrolls?.data;
  
  const [forceRender, setForceRender] = useState(false);

  const forceRerender = () => {
    setForceRender((prev) => !prev);
  };

  const handleSearch = (key, val) => {
    setSearchQuery(val);
    setPage(1);
  };

  const fetchPayrolls = () => {
    let payload = { coll: "Payroll", limit: limit, page: page };
    if (searchQuery) {
      payload.useAggregate = true;
      payload.filters = {
        payDayEmployeesSearch: {
          type: "AG_LOOKUP_DATA",
          value: [
            searchQuery,
            configData?.salaryProfileId?.uiid,
            configData?.payCycle?.from,
            configData?.payCycle?.to,
            1
          ]
        }
      };
    } else {
      payload.ref = "Employee SalProfile PayConfig InsuranceDed RegularDed ShortPay ExcessPay";
      payload.filters = {
        status: { type: "NONE", value: 1 },
        "payCycle.from": { type: "GTE", value: configData?.payCycle?.from },
        "payCycle.to": { type: "LTE", value: configData?.payCycle?.to },
        salaryProfileId: { type: "NONE", value: configData?.salaryProfileId?.uiid },
      };
    }
    dispatch(getAllPayrollStart(payload));
    if (!searchQuery) {
      dispatch(totalCountStart({ collection: "payrolls", coll: "Payroll", filters: payload.filters }));
    }
  };

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {}
  );

  useEffect(() => {
    fetchPayrolls();
    return () => {
      dispatch(clearPayroll());
    };
  }, [dispatch, limit, page, forceRender, searchQuery, configData]);
  const [FinalizeModalOpen, setFinalizeModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);
  const handleEdit = (row) => {
    console.log(row);
  };
  const handleDelete = (row) => {
    console.log(row);
  };
  const handleView = (row) => {
    console.log(row);
  };
  const handleDownload = (row) => {
    console.log(row);
  };

  const columns = [
    {
      key: "employeeName",
      label: "Employee Name",
      width:"min-w-[250px]! max-w-[300px]!",
      render: (row) => {
        const employeeName =
          row?.employeeId?.firstName && row?.employeeId?.lastName
            ? [row?.employeeId?.firstName, row?.employeeId?.lastName]
                .filter(Boolean)
                .join(" ")
            : "-";
        return (
          <SmartTooltip
            description={employeeName}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <span
              className="cursor-pointer text-info line-clamp-1"
              onClick={() => {
                setRowData(row);
                setOpenDrawer(!openDrawer);
              }}
            >
              {employeeName}
            </span>
          </SmartTooltip>
        );
      },
    },
    {
      key: "employeeID",
      label: "Employee ID",
      render: (row) => (
        <span>
          {row?.employeeId?.uiid
            ? getEmployeeId(
                row?.employeeId?.uiid,
                row?.employeeId?.employmentType
              )
            : "-" || "-"}
        </span>
      ),
    },
    {
      key: "employeeCategory",
      label: "Employee Category",
      render: (row) => <span>{row?.salaryProfileId?.name || "-"}</span>,
    },
    {
      key: "salaryType",
      label: "Salary Type",
      render: (row) => (
        <span>
          {row?.payConfigId?.lca?.type === 1
            ? "Monthly"
            : row?.payConfigId?.lca?.type === 2
            ? "Yearly"
            : "-" || "-"}
        </span>
      ),
    },
    {
      key: "lcaMonthly",
      label: "LCA Monthly",
      render: (row) => (
        <span>
          {formatCurrency(
            row?.payConfigId?.lca?.type === 2
              ? row?.payConfigId?.lca?.wages / 12
              : row?.payConfigId?.lca?.wages
          ) || "-"}
        </span>
      ),
    },
    {
      key: "timesheets",
      label: "Timesheets",
      render: (row) => (
        <span> {formatCurrency(row?.timesheets?.totalPay) || "-"}</span>
      ),
    },
    {
      key: "expenses",
      label: "Expenses",
      render: (row) => (
        <span>
          {formatCurrency(
            row?.otherPays?.morePay
              ?.filter((item) =>
                item?.type?.toLowerCase().includes("commission")
              )
              .reduce((sum, item) => sum + (item?.amount || 0), 0)
          ) || "-"}
        </span>
      ),
    },
    {
      key: "deductions",
      label: "Deductions",
      render: (row) => <span>{formatCurrency(row?.amounts?.diff) || "-"}</span>,
    },
    {
      key: "healthInsurance",
      label: "Health Insurance",
      render: (row) => (
        // <span>
        //   {formatCurrency(
        //     row?.deductions?.insurance?.ids?.installments?.find(
        //       (item) => item?.payrollId === row?.uiid
        //     )?.received
        //   ) || "-"}
        // </span>
        <span>{formatCurrency(row?.amounts?.insurance) || "-"}</span>
      ),
    },
    {
      key: "adjustmentPayments",
      label: "Adjustment Payments",
      render: (row) => {
        return <span className="">{"-"}</span>;
      },
    },

    {
      key: "perDiem",
      label: "Per Diem",
      render: (row) => (
        <span>
          {formatCurrency(
            row?.otherPays?.morePay
              ?.filter((item) => item?.type?.toLowerCase().includes("per diem"))
              .reduce((sum, item) => sum + (item?.amount || 0), 0)
          ) || "-"}
        </span>
      ),
    },
    {
      key: "commision",
      label: "Other Payments",
      render: (row) => (
        <span>{formatCurrency(row?.otherPays?.totalAmt) || "-"}</span>
      ),
    },
    {
      key: "total",
      label: "Total",
      render: (row) => (
        <span> {formatCurrency(row?.amounts?.netPay) || "-"}</span>
      ),
    },

    {
      key: "action",
      label: "Action",
      sortable: false,
      render: (row) => (
        <div className="flex gap-1 z-50">
          {/* <ToolTip   description={"Finalize Employee"} tooltipPosition="left" size="xs-sm" noicon> */}
          <Button
            type="icon"
            variant="text"
            icon="check_circle"
            size="sm"
            onClick={() => handleRevertSingle(row.uiid, 2)}
          />
          {/* </ToolTip> */}

          <Button
            type="icon"
            variant="text"
            icon="pause"
            size="sm"
            onClick={() => handleRevertSingle(row.uiid, 3)}
          />
        </div>
      ),
    },
  ];
  const tableData2 = dataArray.map((item) => ({
      id: item.uiid,
      ...item,
    })) || [];
  // const mappedRows = mapTableRows(tableData, columns);
  const mappedRows = mapTableRows(tableData2, columns);

  const handleRevertSingle = async (id, status) => {
    if (!id) {
      showToast("No Payroll Selected To Revert", "info", 3000);
      return;
    }

    dispatch(
      updatePayrollStart({
        uiid: id,
        coll: "Payroll",
        payload: [
          {
            type: "SET",
            value: {
              status: status,
            },
          },
        ],
        customToast:
          status === 2
            ? "Payroll Finalized"
            : status === 3
            ? "Payroll Moved To Hold"
            : undefined,
        onSuccess: () => {
          fetchPayrolls();
        },
      })
    );
  };

  // Handle selection change from TableAdv
  const handleSelectionChange = (selectedRowIds) => {
    console.log("Selected row IDs:", selectedRowIds);
    setSelectedRows(selectedRowIds);

    // Find the actual row objects from mappedRows
    const selectedRowObjects = mappedRows.filter((row) =>
      selectedRowIds.includes(row.id)
    );

    console.log("Selected row objects:", selectedRowObjects);
  };

  return (
    <>
      <TableAdv
        tableId={`payroll_upcomingpaydays_proposedemployees`}
        onSelectionChange={handleSelectionChange}
        defaultSelectedRows={selectedRows}
        fixedCol={2}
        showCheckbox
        rows={mappedRows}
        columns={columns}
        serverPagination={true}
        serverOnSearch={handleSearch}
        page={page}
        limit={limit}
        totalCount={totalCount}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search: true,
          filter: false,
          download: false,
          add: [
            {
              component: <Button title="Search" size="sm" />,
            },
            {
              component: (
                <DropdownMenu
                  MenuSection={
                    <div className="flex flex-col">
                      <Button
                        title={"EXCEL"}
                        variant="text"
                        color="black"
                        size="xs-sm"
                        className="!justify-start py-1"
                      />
                      <Button
                        title={"CSV"}
                        variant="text"
                        color="black"
                        size="xs-sm"
                        className="!justify-start py-1"
                      />
                    </div>
                  }
                >
                  <Button
                    color="black"
                    title=""
                    size="md"
                    icon={"screen_share"}
                    variant="text"
                  />
                </DropdownMenu>
              ),
            },
          ],
        }}
      />
      <div>
        <Drawer
          isOpen={openDrawer}
          onClose={() => {
            setOpenDrawer(false);
            setRowData({});
            dispatch(clearCurrentPayrollEditing());
            fetchPayrolls();
          }}
          position="left" // 'left', 'right', 'top', 'bottom'
          width="w-[80%]" // custom width using Tailwind classes
          title=""
          closeOnOutsideClick
          showCloseButton={false}
          className="!p-0"
          bodyGap={false}
        >
          <div>
            <ProposedEmployeesDetails
              onHoldClick={() => {
                setOpenDrawer(false);
                setRowData({});
                fetchPayrolls();
              }}
              rowData={rowData}
            />
          </div>
        </Drawer>
      </div>
      <FinalizeModal
        isOpen={FinalizeModalOpen}
        onClose={() => setFinalizeModalOpen(false)}
      />
    </>
  );
};

export default ProposedEmployees;
